import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

const WhatsAppButton = ({
  phoneNumber = "5554999062213",
  message = "Olá! Gostaria de saber mais sobre seus serviços.",
}) => {
  // Format the WhatsApp URL with phone number and encoded message
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-floating-button"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Iniciar conversa no WhatsApp"
    >
      <FaWhatsapp />
      <span className="whatsapp-tooltip">Fale conosco</span>
    </a>
  );
};

export default WhatsAppButton;
